<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />
    <Dialog
      id="'dialog-client-signature-report'"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw', position: 'relative' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :closable="false"
      :header="'Assinatura do Cliente para Relatório'"
    >
      <Loading
        :active.sync="loading"
        :isFullPage="false"
        :zIndex="9000"
      ></Loading>
      <form
        name="equipamentExtarPhotosForm"
        class="p-col-12"
        @submit.prevent="saveSignature"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="current-signature" v-if="signature">
              <img :src="signature" alt="Assinatura atual">
          </div>
          <div v-else class="p-field p-col-12 p-md-12 signature-box">
            <VueSignaturePad
              ref="signaturePad"
              :options="signaturePadOptions"
            />
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :disabled="signature || loading"
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-success"
          @click="saveSignature"
        />
        <Button
          :disabled="loading"
          :label="'Limpar'"
          icon="pi pi-eraser"
          class="p-button-info"
          @click.prevent="undo"
        />
        <Button
          :disabled="loading"
          label="Fechar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";

export default {
  name: "DialogClientSignatureReport",
  props: {
    show: {
        type: Boolean,
        default: false
    },
    taskId: {
        required: true
    }
  },
  components: { Loading },
  watch: {
    async show(newVal) {
      if (newVal === true) {
        await this.getInterventionTask();
        window.addEventListener('resize', this.resizePad);

        this.$nextTick(() => {
          setTimeout(() => {
            this.resizePad();
          }, 200);
        });

      } else {
        window.removeEventListener('resize', this.resizePad);
        this.reset();
      }
    },
  },
  data() {
    return {
      loading: false,
      signature: null,
      signaturePadOptions: {
        onBegin: () => {
          // Opcional
        },
        onEnd: () => {
          // Opcional
        }
      }
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizePad);
  },
  methods: {
    resizePad() {
      try {
        const signaturePad = this.$refs.signaturePad;

        if (!signaturePad || !signaturePad.$el) {
          console.warn('SignaturePad ref não disponível');
          return;
        }

        const canvas = signaturePad.$el.querySelector('canvas');

        if (!canvas) {
          console.warn('Canvas não encontrado');
          return;
        }

        const currentData = signaturePad.saveSignature ? signaturePad.saveSignature() : null;

        const containerWidth = signaturePad.$el.clientWidth || 300;
        const containerHeight = 500;

        canvas.width = containerWidth;
        canvas.height = containerHeight;

        canvas.style.width = containerWidth + 'px';
        canvas.style.height = containerHeight + 'px';

        if (currentData && !currentData.isEmpty && signaturePad.fromDataURL) {
          signaturePad.fromDataURL(currentData.data);
        }

        if (signaturePad.resizeCanvas) {
          signaturePad.resizeCanvas();
        }
      } catch (error) {
        console.error('Erro ao redimensionar signature pad:', error);
      }
    },
    reset() {
      this.loading = false;
      this.signature = null;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    undo() {
      if (this.$refs.signaturePad && this.$refs.signaturePad.clearSignature) {
        this.$refs.signaturePad.clearSignature();
      }

      this.signature = null;

      this.$nextTick(() => {
        setTimeout(() => {
          this.resizePad();
        }, 200);
      });
    },
    async saveSignature() {
      if (!this.$refs.signaturePad) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Componente de assinatura não está disponível. Por favor, tente novamente.",
          life: 3000,
        });
        return;
      }

      this.loading = true;
      try {
        const signaturePad = this.$refs.signaturePad;

        if (!signaturePad.saveSignature) {
          throw new Error('Método saveSignature não disponível');
        }

        const result = signaturePad.saveSignature();

        if (!result || typeof result !== 'object') {
          throw new Error('Resultado inválido do saveSignature');
        }

        const { isEmpty, data } = result;

        if (isEmpty || !data) {
          this.$toast.add({
            severity: "warn",
            summary: "Assinatura não preenchida",
            detail: "Por favor, assine antes de guardar",
            life: 3000,
          });
          this.loading = false;
          return;
        }

        await supportService.addInterventionClientSignature(this.taskId, { data });

        this.$toast.add({
          severity: "success",
          summary: "Assinatura registada",
          detail: "Assinatura guardada com sucesso",
          life: 3000,
        });

        this.$emit('saveSignature');

        await this.getInterventionTask();

      } catch (error) {
        console.error('Erro ao guardar assinatura:', error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao guardar assinatura",
          detail: error.message || "Ocorreu um erro. Por favor, tente novamente.",
          life: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
    async getInterventionTask() {
      try {
        this.loading = true;
        const response = await supportService.getInterventionTask(this.taskId);

        if (!response) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao obter dados",
            detail: "Ocorreu um erro ao obter dados da tarefa",
            life: 3000,
          });
          return;
        }

        this.signature = response.status?.client_signature_data || null;
      } catch (error) {
        console.error('Erro ao obter tarefa:', error);
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível carregar os dados da tarefa",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
<style scoped>
.signature-box {
    margin-top: 10px;
    border: 3px dashed #888;
    width: 100%;
    line-height: 0;
    overflow: hidden;
    border-radius: 4px;
    min-height: 300px;
}

.signature-box >>> canvas {
    width: 100% !important;
    height: auto !important;
    touch-action: none;
}

.current-signature {
    width: 100%;
    max-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.current-signature img {
    max-width: 100%;
    height: auto;
}
</style>